// extracted by mini-css-extract-plugin
module.exports = {"row":"EnrollClinic_row__1rc8I"};